module.exports = __webpack_public_path__ + "static/media/IconBoxDeal.47912d4d.svg";